import { w as withConfigTransport } from "../../services/config-transport/withConfigTransport-2705a6a5.mjs";
import { _ as _VaCarousel } from "./VaCarousel-836346b4.mjs";
const VaCarousel = withConfigTransport(_VaCarousel);
export {
  VaCarousel as V
};
//# sourceMappingURL=index-0815012c.mjs.map
